export enum TipoVehiculo
{
    Auto = "Auto",
    Buses = "Buses",
    Camiones = "Camiones",
    Camionetas = "Camionetas",
    Furgón = "Furgón",
    Maquinaría = "Maquinaria",  
    Moto = "Moto",    
    Suv = "Suv"
}